import { memo } from 'react';
import { MdArrowForward } from 'react-icons/md';
import { MobileHomeListData, MobileHomeListItem, MOBILE_HOME_ITEM_TYPES } from '@shared/types/frontend/tables';
import { IoIosArrowBack } from 'react-icons/io';
import Loading from '@/components/shared/Loading';
import { Switch } from '@/components/ui/switch';
import { Button } from '@/components/ui/button';
import NormieCategories from './NormieCategories';
import MobileMemeMode from './MobileMemeMode';
import TopMobileResults from '../TopMobileResults';
import TokenCard from '../TokenCard';
import RecentResults from './RecentResults';
import TodayTopGainers from './TodayTopGainers';
import CashResults from '../CashResult';
import LaunchPadView from '../LaunchPadView';
import { toSpecialFixed } from '@/lib/misc/utils';
interface VirtualizedRowProps {
  index: number;
  style: React.CSSProperties;
  data: {
    items: MobileHomeListItem[];
  } & MobileHomeListData;
}
const HomeRow = ({
  index,
  style,
  data: {
    items,
    ...props
  }
}: VirtualizedRowProps) => {
  const item = items[index];
  switch (item.type) {
    /* SHARED */

    case MOBILE_HOME_ITEM_TYPES.LOADING:
      return <div style={style} className={item.data?.className ?? 'w-full flex items-center flex-col justify-center'}>
          <Loading className={item.data?.className ?? 'h-8 w-8'} />
        </div>;
    case MOBILE_HOME_ITEM_TYPES.TOKEN_RESULT:
      {
        const {
          tokenItem,
          searchResult,
          isTop10,
          isSingleResult
        } = item.data;
        const result = <div style={style}>
          <div className={isSingleResult ? 'gradient-genius-sides mx-3 rounded-[12px] border-genius-blue border-[1px] relative' : undefined}>
            {isTop10 ? <TopMobileResults searchResult={searchResult} timeFrame={props.timeFrame} onTokenClick={props.onTokenClick} /> : <TokenCard tokenItem={tokenItem} timeFrame={props.timeFrame} searchResult={searchResult} handleTokenClick={props.handleTokenClick} onTokenClick={props.onTokenClick} mode={props.mode} setIsAssetModalOpen={props.setIsAssetModalOpen} setAssetModalData={props.setAssetModalData} />}
            {/* {isSingleResult && showOrder && (
              <span
                key={animationKey}
                className={`absolute bottom-[-38px] left-[0px] w-fit h-[26px] text-[12px] text-black rounded-full px-3 flex items-center bg-[${showOrder.type === 'buy' ? '#34D399' : '#F87171'}] fade-animation`}
              >
                <BiSolidUser className='mr-1' />
                {showOrder.type === 'buy'
                  ? `Buy: ${showOrder.amount}`
                  : `Sell: ${showOrder.amount}`}
              </span>
             )} */}
          </div>
        </div>;
        return result;
      }

    /* HOME PAGE */

    case MOBILE_HOME_ITEM_TYPES.USER_FUNDS:
      return <div style={style} className={`ta-c w-full flex items-center ${props.keyword === '' ? 'border-genius-blue border-b-[1px]' : ' '}`}>
          {props.isUserWithFunds ? props.isLoadingAssetData ? <Loading className='p-4 h-6 w-6 my-1' /> : !props.urlHasTrade ? <div onClick={() => {
          props.setMobileMode('portfolio');
          //shallow push window
          window.history.pushState({}, '', '/home?m_mode=portfolio');
        }} className='w-full'>
                <div className='ta-l pl-2 w-[95%] rounded-md py-2 flex justify-between items-center'>
                  <div className='flex text-[32px] text-genius-cream'>
                    ${toSpecialFixed(props.assetData.totalUsdValue, 2)?.value}
                  </div>
                  <div>
                    <MdArrowForward className={'w-[20px] h-[20px] text-genius-cream/50 mr-4'} />
                  </div>
                </div>
              </div> : null : <>
              <Button onClick={() => props.setIsDepositModalOpen(true)} variant='pink' className='w-[90%] m-auto rounded-full h-[56px]'>
                Deposit Cash or Crypto
              </Button>
            </>}
        </div>;
    case MOBILE_HOME_ITEM_TYPES.RECENTLY_LISTED_HEADER:
      return <div style={style}>
          <p className='text-[16px] text-genius-gradient flex items-center px-4 py-3'>
            Recently Listed
          </p>
        </div>;
    case MOBILE_HOME_ITEM_TYPES.RECENT_RESULTS:
      return <div style={style} className='flex items-center border-genius-blue border-b-[1px]'>
          <RecentResults onTokenClick={props.onTokenClick} data={item.data.recentItems} />
        </div>;
    case MOBILE_HOME_ITEM_TYPES.TOP_GAINERS:
      return <div style={style} className='flex items-center border-genius-blue border-b-[1px]'>
          <TodayTopGainers timeFrame={item.data.timeFrame} onTokenClick={props.onTokenClick} subMemeData={item.data.subMemeData} network={item.data.network} loading={item.data.loading} />
        </div>;
    case MOBILE_HOME_ITEM_TYPES.TRENDING_TITLE:
      return <p style={style} className='text-[16px] text-genius-gradient flex items-end px-4 pb-1'>
          Trending
        </p>;

    /* SEARCH MODE */

    case MOBILE_HOME_ITEM_TYPES.SAVED_HEADER:
      return <div style={style}>
          <div className='flex items-center justify-between px-3'>
            <Button className='bg-genius-blue text-genius-cream text-[14px] rounded-full py-2 pl-3 h-auto gap-1' onClick={() => props.setMode('recent')}>
              <IoIosArrowBack className='text-genius-cream' />
              Back
            </Button>
            <div className='ta-c'>
              <p className='text-genius-cream text-[16px]'>Saved</p>
            </div>
            <Button className='bg-genius-blue text-genius-cream text-[14px] rounded-full py-2 h-auto' onClick={item.data.handleClearSavedTokens}>
              Clear
            </Button>
          </div>
        </div>;
    case MOBILE_HOME_ITEM_TYPES.SAFE_SEARCH:
      return <div style={style} className='flex justify-between px-4 text-genius-cream items-center border-genius-blue border-y-[1px] py-4'>
          <div className=''>Safe Search</div>
          <Switch checked={!props.wildWest} onClick={() => props.showWildWest(!props.wildWest)} />
        </div>;
    case MOBILE_HOME_ITEM_TYPES.NORMIE_CATEGORIES:
      return <div style={style} className='flex items-end'>
          <NormieCategories setKeyword={props.setKeyword} mode={props.mode} setMode={props.setMode} />
        </div>;
    case MOBILE_HOME_ITEM_TYPES.MEME_MODE:
      return <div style={style} className='flex items-center pb-1'>
          <MobileMemeMode setMode={props.setMode} subMode={props.subMode} setSubMode={props.setSubMode} />
        </div>;
    case MOBILE_HOME_ITEM_TYPES.WARNING_MESSAGE:
      return <div style={style} className='flex items-center px-4'>
          <div className='text-[12px] text-genius-cream border-red-400 border-[1px] rounded-[20px] bg-[#F8717126] py-2.5 px-4'>
            Trending tokens are algorithmically sourced from on-chain data. They are not vetted for
            honeypots or scams. Genius is not responsible for lost funds. Exercise caution when
            trading.
          </div>
        </div>;
    case MOBILE_HOME_ITEM_TYPES.TOP_10_HEADER:
      return <div style={style} className='flex items-end'>
          <p className='text-genius-gradient text-[16px] pl-4 ta-l'>Top 10</p>
        </div>;
    case MOBILE_HOME_ITEM_TYPES.ALL_TOKENS_HEADER:
      return <div style={style} className='flex items-end'>
          <p className='text-genius-gradient text-[16px] pl-4 ta-l'>All Tokens</p>
        </div>;
    case MOBILE_HOME_ITEM_TYPES.LOW_VOLUME_BUTTON:
      return <div style={style} className='flex justify-center items-center'>
          <div className='w-fit bg-genius-blue rounded-full p-2 px-4 text-genius-cream text-[12px]' onClick={() => props.setUseUnprotectedSearch(true)}>
            Show Low Volume Results
          </div>
        </div>;
    case MOBILE_HOME_ITEM_TYPES.NO_RESULTS:
      return <div style={style} className='text-genius-cream/50 mx-auto justify-center ta-c text-base flex items-center flex-col'>
          {props.mode === 'search' ? 'No Search Results' : props.mode === 'new' ? 'No New Tokens in the last 24 hours' : 'No Results'}
          {props.mode === 'search' && !props.useUnprotectedSearch && <div className='bg-genius-blue rounded-full p-2 px-4 text-genius-cream mt-4 text-[12px]' onClick={() => props.setUseUnprotectedSearch(true)}>
              Show Low Volume Results
            </div>}
        </div>;
    case MOBILE_HOME_ITEM_TYPES.CASH_RESULTS:
      return <div style={style}>
          <CashResults setCashModalData={props.setCashModalData} />
        </div>;
    case MOBILE_HOME_ITEM_TYPES.LAUNCHPAD:
      return <div style={style}>
          <LaunchPadView />
        </div>;
    default:
      return null;
  }
};
HomeRow.displayName = 'VirtualizedRow';
export default memo(HomeRow);